import { Pipe, PipeTransform } from '@angular/core';
import {
  DefaultCurrencyDecimalMarker,
  DefaultCurrencyDecimalsMask,
  DefaultCurrencyMask,
  DefaultCurrencyThousandSeparator
} from '@core/models/config.model';
import { ConfigService } from '@core/services/config.service';
import { MaskApplierService } from 'ngx-mask';

@Pipe({
  name: 'configCurrency',
  pure: false
})
export class ConfigCurrencyPipe implements PipeTransform {
  constructor(private configService: ConfigService, private maskApplierService: MaskApplierService) {}

  transform(value: any, args?: any): any {
    // This function is replicated from the MaskPipe in order to be able to add
    // the 'decimalMarker' value.
    if (!value && typeof value !== 'number') {
      return '';
    }
    const mask =
      +value >= 100
        ? this.configService.config?.currencyConstraints.masking?.mask || DefaultCurrencyMask
        : DefaultCurrencyDecimalsMask;
    const thousandSeparator =
      this.configService.config?.currencyConstraints.masking?.thousandSeparator || DefaultCurrencyThousandSeparator;
    const decimalMarker =
      this.configService.config?.currencyConstraints.masking?.decimalMarker || DefaultCurrencyDecimalMarker;
    if (thousandSeparator) {
      this.maskApplierService.thousandSeparator = thousandSeparator;
    }
    if (decimalMarker) {
      this.maskApplierService.decimalMarker = decimalMarker;
    }
    let stringValue = `${value}`;
    // If the value is a number and our thousandSeparator is a 'dot', the
    // value string should have its 'dots' replaced by the applied decimalMarker
    // which can only be a 'comma'.
    if (!isNaN(value) && thousandSeparator === '.') {
      stringValue = stringValue.replace('.', ',');
    }
    if (typeof mask === 'string') {
      return this.maskApplierService.applyMask(stringValue, mask);
    }
    return this.maskApplierService.applyMaskWithPattern(stringValue, mask);
  }
}
